/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { ToastUtility } from "@syncfusion/ej2-notifications";
import { useEffect, useRef, useState } from "react";
import { read, utils } from "xlsx";

import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

type Subsidiary = {
	activity: string;
	address: string;
	name: string;
	id?: number;
};

function dangerShow(msj: string) {
	ToastUtility.show(msj, "Error", 4000);
}

function SubsidiaryRowForm({
	subsidiary,
	subsidiaries,
	setSubsidiaries,
	setShowRowForm,
	setEditingRowID,
}: {
	subsidiary: Subsidiary;
	subsidiaries: Array<Subsidiary>;
	setSubsidiaries: React.Dispatch<React.SetStateAction<Array<Subsidiary>>>;
	setShowRowForm: React.Dispatch<React.SetStateAction<boolean>>;
	setEditingRowID: React.Dispatch<React.SetStateAction<number>>;
}) {
	//const [showRowForm, setShowRowForm] = useState(false);
	const [editingRowId, setEditingRowId] = useState(subsidiary.id);
	const [subsidiaryName, setSubsidiaryName] = useState(subsidiary.name);
	const [subsidiaryAddress, setSubsidiaryAddress] = useState(subsidiary.address);
	const [subsidiaryActivity, setSubsidiaryActivity] = useState(subsidiary.activity);

	function toastCreated() {
		dangerShow("Debe completar todos los campos de la sucursal.");
	}

	function handleChangeSubsidiaryName(event: React.ChangeEvent<HTMLInputElement>) {
		setSubsidiaryName(event.target.value);
	}

	function handleChangeSubsidiaryAddress(event: React.ChangeEvent<HTMLInputElement>) {
		setSubsidiaryAddress(event.target.value);
	}

	function handleChangeSubsidiaryActivity(event: React.ChangeEvent<HTMLInputElement>) {
		setSubsidiaryActivity(event.target.value);
	}

	function handleClickSaveRow() {
		if (!subsidiaryAddress || !subsidiaryName) {
			toastCreated();

			return;
		}
		if (editingRowId) {
			setSubsidiaries(
				subsidiaries.map((s) =>
					s.id === editingRowId
						? {
								activity: subsidiaryActivity,
								address: subsidiaryAddress,
								name: subsidiaryName,
								id: editingRowId,
						  }
						: { ...s }
				)
			);
		} else {
			if (subsidiaries) {
				setSubsidiaries([
					...subsidiaries,
					{
						activity: subsidiaryActivity,
						address: subsidiaryAddress,
						name: subsidiaryName,
						id: Math.floor(Math.random() * 10000),
					},
				]);
			} else {
				setSubsidiaries([
					{
						activity: subsidiaryActivity,
						address: subsidiaryAddress,
						name: subsidiaryName,
						id: Math.floor(Math.random() * 10000),
					},
				]);
			}
		}

		resetForm();
	}

	function handleClickCancelRow() {
		resetForm();
	}

	function resetForm() {
		setShowRowForm(false);
		setEditingRowId(0);
		setEditingRowID(0);
		setSubsidiaryName("");
		setSubsidiaryAddress("");
		setSubsidiaryActivity("");
	}

	return (
		<>
			<tr key={editingRowId} className="add-item">
				<td>
					<input
						name="subsidiaryName"
						id="subsidiaryName"
						type="text"
						value={subsidiaryName}
						onChange={handleChangeSubsidiaryName}
					/>
				</td>
				<td>
					<input
						name="subsidiaryAddress"
						id="subsidiaryAddress"
						type="text"
						value={subsidiaryAddress}
						onChange={handleChangeSubsidiaryAddress}
					/>
				</td>
				<td>
					<input
						name="subsidiaryActivity"
						id="subsidiaryActivity"
						type="text"
						value={subsidiaryActivity}
						onChange={handleChangeSubsidiaryActivity}
					/>
				</td>
				<td>
					<span className="actionButtonsWrapper">
						<button className="btn-small" type="button" onClick={handleClickSaveRow}>
							Guardar
						</button>
						<button className="btn-small" type="button" onClick={handleClickCancelRow}>
							Cancelar
						</button>
					</span>
				</td>
			</tr>
		</>
	);
}

function SubsidiariesTable({
	subsidiaries,
	setSubsidiaries,
}: {
	subsidiaries: Array<Subsidiary>;
	setSubsidiaries: React.Dispatch<React.SetStateAction<Array<Subsidiary>>>;
}) {
	const [showRowForm, setShowRowForm] = useState(false);
	const [editingRowId, setEditingRowId] = useState(0);

	function toastCreated() {
		dangerShow("El archivo no respeta el formato");
	}

	function handleClickShowAddRow() {
		setShowRowForm(!showRowForm);
		setEditingRowId(0);
	}

	function handleClickEditRow(subsidiary: Subsidiary) {
		setEditingRowId(subsidiary.id);
	}

	function handleClickDeleteRow(subsidiaryName: string) {
		setSubsidiaries(subsidiaries.filter((e) => e.name !== subsidiaryName));
	}

	async function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
		const file = e.target.files[0];
		if (file) {
			const arrayBuffer = await file.arrayBuffer();
			const wb = read(arrayBuffer);
			if (
				wb.Strings &&
				wb.Strings[0].t === "Nombre" &&
				wb.Strings[1].t === "Dirección" &&
				wb.Strings[2].t === "Actividad"
			) {
				let data = utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
				try {
					data = [...new Map(data.map((item) => [item["Nombre"], item])).values()];
				} catch (error) {}
				const importedSubsidiaries = data.map((element) => {
					return {
						activity: element.Actividad,
						address: element["Dirección"],
						name: element.Nombre,
						id: Math.floor(Math.random() * 10000),
					};
				});
				subsidiaries?.forEach((e) => {
					if (
						!importedSubsidiaries.some((sub) => sub.name.toLowerCase() === e.name.toLowerCase())
					) {
						importedSubsidiaries.push(e);
					}
				});
				setSubsidiaries(importedSubsidiaries);
			} else {
				toastCreated();
			}
		}
	}

	function download(e: React.MouseEvent<HTMLLinkElement>) {
		fetch(`${process.env.PUBLIC_URL}/files/Planilla_para_sucursales.xlsx`)
			.then((response) => response.blob())
			.then((blob) => {
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = "Planilla_para_sucursales.xlsx";
				link.click();
			})
			.catch(console.error);

		e.preventDefault();
	}

	return (
		<>
			<div>
				<label htmlFor="excelFile">
					<div>{"Importar listado (excel) "}</div>
					<button
						//className="btn-small"
						type="button"
						disabled={Boolean(editingRowId) || showRowForm}
						onClick={handleClickShowAddRow}
					>
						Agregar Sucursal
					</button>
					<input
						type="file"
						name="excelFile"
						disabled={Boolean(editingRowId) || showRowForm}
						onChange={handleFileChange}
					/>
					<a href="" className="ejemplo" onClick={download}>
						{"(Ejemplo)"}
					</a>
				</label>
			</div>
			<table>
				<tbody>
					{showRowForm && (
						<>
							<tr className="add-item">
								<th>Nombre</th>
								<th>Dirección</th>
								<th>Actividad</th>
								<th></th>
							</tr>
							<SubsidiaryRowForm
								{...{
									subsidiary: { name: "", address: "", activity: "", id: 0 },
									subsidiaries,
									setSubsidiaries,
									setShowRowForm,
									setEditingRowID: setEditingRowId,
								}}
							/>
						</>
					)}
					{subsidiaries?.map((s) => {
						return editingRowId === s.id ? (
							<SubsidiaryRowForm
								{...{
									subsidiary: s,
									subsidiaries,
									setSubsidiaries,
									setShowRowForm,
									setEditingRowID: setEditingRowId,
								}}
							/>
						) : (
							<tr key={s.id} className="add-item">
								<td>{s.name}</td>
								<td>{s.address}</td>
								<td>{s.activity}</td>
								<td className="tdActionButtonsWrapper">
									<span className="actionButtonsWrapper">
										<button
											className="btn-small"
											type="button"
											disabled={Boolean(editingRowId) || showRowForm}
											onClick={() => handleClickEditRow(s)}
										>
											Editar
										</button>
										<button
											className="btn-small"
											type="button"
											disabled={Boolean(editingRowId) || showRowForm}
											onClick={() => handleClickDeleteRow(s.name)}
										>
											Borrar
										</button>
									</span>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</>
	);
}

function OrganizationSite() {
	const [organizationSiteHasSubsidiaries, setOrganizationSiteHasSubsidiaries] = useState(false);
	const { currentStep, countryBrandApplication, update, formRef, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const [subsidiaries, setSubsidiaries] = useState<Array<Subsidiary>>([]);

	const { applicantCompanyAddress } = countryBrandApplication;

	useEffect(() => {
		setSubsidiaries(
			countryBrandApplication.organizationSiteSubsidiaries?.map((e) => {
				return { ...e, id: Math.floor(Math.random() * 10000) };
			})
		);
		setOrganizationSiteHasSubsidiaries(
			Boolean(countryBrandApplication.organizationSiteSubsidiaries?.length)
		);
	}, [countryBrandApplication]);

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		function submitStepData() {
			const formElement = formRef.current as HTMLFormElement;
			const applicantCompanyAddress = formElement.elements.applicantCompanyAddress.value;
			const organizationSiteHasSubsidiaries =
				formElement.elements.organizationSiteHasSubsidiaries.value;

			update({
				data: {
					applicantCompanyAddress,
					organizationSiteSubsidiaries: organizationSiteHasSubsidiaries
						? subsidiaries.map((e) => {
								return { name: e.name, address: e.address, activity: e.activity };
						  })
						: [],
				},
				nextStep: currentStep + 1,
			});
		}

		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, [subsidiaries]);

	function handleOnChangeOrganizationSiteHasSubsidiaries(
		event: React.ChangeEvent<HTMLInputElement>
	) {
		setOrganizationSiteHasSubsidiaries(event.target.checked);
	}

	return (
		<div className="step-page" id="step-4">
			<section>
				<h3>4 - Dirección de la empresa</h3>
				<label htmlFor="applicantCompanyAddress">
					Dirección *
					<input
						type="text"
						name="applicantCompanyAddress"
						id="applicantCompanyAddress"
						required
						defaultValue={applicantCompanyAddress}
					/>
				</label>
				<label className="checked-input" htmlFor="organizationSiteHasSubsidiaries">
					<input
						name="organizationSiteHasSubsidiaries"
						id="organizationSiteHasSubsidiaries"
						type="checkbox"
						checked={organizationSiteHasSubsidiaries}
						onChange={handleOnChangeOrganizationSiteHasSubsidiaries}
					/>
					Tiene sucursales
				</label>
				{organizationSiteHasSubsidiaries && (
					<SubsidiariesTable {...{ subsidiaries, setSubsidiaries }} />
				)}
			</section>
		</div>
	);
}

export { OrganizationSite };
